import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  // mode: 'history',
  routes: [
    {
      name: "index",
      path: "/",
      component: (resolve) => require(["@/components/page/Login.vue"], resolve),
      meta: {
        title: "全品满分学堂",
        roles: ["teacher", "patriarch", "student"],
      },
    },
    {
      name: "index",
      path: "/index",
      component: (resolve) => require(["@/components/page/Index.vue"], resolve),
      meta: {
        title: "全品满分学堂",
        roles: ["teacher", "patriarch", "student"],
      },
    },
    {
      name: "terminal",
      path: "/terminal/video/exercise",
      meta: {
        title: "终端视频答题",
      },
      component: (resolve) => require(["@/components/page/TerminalVideoExercise.vue"], resolve),
    },
    {
      name: "terminal",
      path: "/terminal/question",
      meta: {
        title: "终端题目查询",
      },
      component: (resolve) => require(["@/components/page/TerminalQuestion.vue"], resolve),
    },
    {
      name: "terminal",
      path: "/terminal/error/question",
      meta: {
        title: "错题筛选",
      },
      component: (resolve) => require(["@/components/page/TerminalErrorQuestion.vue"], resolve),
    },
    {
      path: "/",
      component: (resolve) =>
        require(["@/components/common/Main.vue"], resolve),
      meta: { title: "" },
      children: [
        {
          name: "list",
          path: "/list",
          component: (resolve) =>
            require(["@/components/page/List.vue"], resolve),
          meta: {
            title: "首页",
            roles: ["teacher", "student"],
          },
        },
        {
          name: "video",
          path: "video/:vid",
          component: (resolve) =>
            require(["@/components/page/Video.vue"], resolve),
          meta: {
            title: "视频播放页",
            roles: ["teacher", "student"],
          },
        },
        {
          name: "user",
          path: "user",
          component: (resolve) =>
            require(["@/components/page/StudentUser.vue"], resolve),
          meta: { title: "个人中心", roles: ["student"] },
        },
        {
          name: "studentWeaknesses",
          path: "student/weaknesses",
          component: (resolve) =>
            require(["@/components/page/StudentWeaknesses.vue"], resolve),
          meta: { title: "弱科分析", roles: ["student"] },
        },
        {
          name: "studentNews",
          path: "student/news",
          component: (resolve) =>
            require(["@/components/page/StudentNews.vue"], resolve),
          meta: { title: "消息通知", roles: ["student"] },
        },
        {
          name: "conversion",
          path: "conversion",
          component: (resolve) =>
            require(["@/components/page/Conversion.vue"], resolve),
          meta: { title: "兑换中心", roles: ["teacher", "student"] },
        },
        {
          name: "teacher",
          path: "teacher",
          component: (resolve) =>
            require(["@/components/common/TeacherClassMain.vue"], resolve),
          meta: { title: "教师班级管理", roles: ["teacher"] },
          children: [
            {
              name: "teacherClass",
              path: "class",
              component: (resolve) =>
                require(["@/components/page/TeacherClass.vue"], resolve),
              meta: { title: "教师班级管理", roles: ["teacher"] },
            },
            {
              name: "teacherAssignment",
              path: "assignment",
              component: (resolve) =>
                require(["@/components/page/TeacherAssignment.vue"], resolve),
              meta: { title: "班级作业", roles: ["teacher"] },
            },
            {
              name: "teacherIntelligence",
              path: "intelligence",
              component: (resolve) =>
                require(["@/components/page/TeacherIntelligence.vue"], resolve),
              meta: { title: "智能组卷", roles: ["teacher"] },
            },
            {
              name: "teacherSituation",
              path: "situation",
              component: (resolve) =>
                require(["@/components/page/TeacherSituation.vue"], resolve),
              meta: { title: "学情管理", roles: ["teacher"] },
            },
          ],
        },
        {
          name: "teacherResource",
          path: "teacher/file",
          component: (resolve) =>
            require(["@/components/common/TeacherPrepareLessonsMain.vue"], resolve),
          meta: { title: "备课", roles: ["teacher"] },
          children: [
            {
              name: "TeacherFileResource",
              path: "resource",
              component: (resolve) =>
                require(["@/components/page/TeacherResource.vue"], resolve),
              meta: { title: "资源下载", roles: ["teacher"] },
            },
            {
              name: "TeacherFileNote",
              path: "note",
              component: (resolve) =>
                require(["@/components/page/TeacherDownloadNote.vue"], resolve),
              meta: { title: "资源下载", roles: ["teacher"] },
            },
          ],
        },
        {
          name: "patriarch",
          path: "patriarch",
          component: (resolve) =>
            require(["@/components/common/PatriarchUserMain.vue"], resolve),
          meta: { title: "教师管理中心", roles: ["patriarch"] },
          children: [
            {
              name: "patriarchInform",
              path: "inform",
              component: (resolve) =>
                require(["@/components/page/PatriarchInform.vue"], resolve),
              meta: { title: "通知", roles: ["patriarch"] },
            },
            {
              name: "patriarchLearningCondition",
              path: "learning/condition",
              component: (resolve) =>
                require(["@/components/page/PatriarchLearningCondition.vue"], resolve),
              meta: { title: "孩子学情报告", roles: ["patriarch"] },
            },
          ]
        },
        {
          name: "student",
          path: "student",
          component: (resolve) =>
            require(["@/components/common/StudentExerciseMain.vue"], resolve),
          meta: { title: "学生管理", roles: ["student"] },
          children: [
            {
              name: "studentZiHuiXue",
              path: "zihuixue",
              component: (resolve) =>
                require(["@/components/page/StudentZiHuiXue.vue"], resolve),
              meta: { title: "智慧学", roles: ["student"] },
            },
            {
              neme: "studentErrorBooks",
              path: "errorbooks",
              component: (resolve) =>
                require(["@/components/page/StudentErrorBooks.vue"], resolve),
              meta: { title: "错题本", roles: ["student"] },
            },
            {
              name: "studentBooks",
              path: "books",
              component: (resolve) =>
                require(["@/components/page/StudentBooks.vue"], resolve),
              meta: { title: "作业册", roles: ["student"] },
            },
          ],
        },
        {
          name: "studentHomework",
          path: "/student/homework/:homeworkcode",
          component: (resolve) =>
            require(["@/components/page/StudentHomework.vue"], resolve),
          meta: { title: "作业作答", roles: ["student"] },
        },
        {
          name: "studentZihuixue",
          path: "student/zihuixue",
          component: (resolve) =>
            require(["@/components/common/StudentLearnMain.vue"], resolve),
          meta: { title: "学生管理", roles: ["student"] },
          children: [
            {
              name: "studentLearn",
              path: "learn/:cid",
              component: (resolve) =>
                require([
                  "@/components/page/StudentZiHuiXueLearn.vue",
                ], resolve),
              meta: { title: "先学后练", roles: ["student"] },
            },
            {
              name: "studentLearning",
              path: "learning/:cid",
              component: (resolve) =>
                require([
                  "@/components/page/StudentZiHuiXueLearnIng.vue",
                ], resolve),
              meta: { title: "边学边练", roles: ["student"] },
            },
            {
              name: "studentLearned",
              path: "learned/:cid",
              component: (resolve) =>
                require([
                  "@/components/page/StudentZiHuiXueLearnEd.vue",
                ], resolve),
              meta: { title: "直接闯关", roles: ["student"] },
            },
          ],
        },
      ],
    },
    {
      name: "ti",
      path: "/ti",
      component: (resolve) =>
        require(["@/components/common/TiMain.vue"], resolve),
      meta: { title: "试题", roles: ["teacher"] },
      children: [
        {
          name: "tiKnowledge",
          path: "knowledge",
          component: (resolve) =>
            require(["@/components/page/TiKnowledge.vue"], resolve),
          meta: { title: "知识点选题", roles: ["teacher"] },
        },
        {
          name: "tiBrowse",
          path: "browse",
          component: (resolve) =>
            require(["@/components/page/TiBrowse.vue"], resolve),
          meta: { title: "试题篮浏览", roles: ["teacher"] },
        },

        {
          name: "tiDetail",
          path: "detail/:qid/:types",
          component: (resolve) =>
            require(["@/components/page/TiDetail.vue"], resolve),
          meta: { title: "作业选题", roles: ["teacher"] },
        },
      ],
    },
    {
      name: "work",
      path: "/work",
      component: (resolve) =>
        require(["@/components/common/TiMainWork.vue"], resolve),
      meta: { title: "试题", roles: ["teacher"] },
      children: [
        {
          name: "workKnowledge",
          path: "knowledge",
          component: (resolve) =>
            require(["@/components/page/WorkKnowledge.vue"], resolve),
          meta: { title: "作业知识点选题", roles: ["teacher"] },
        },
        {
          name: "workBrowse",
          path: "browse",
          component: (resolve) =>
            require(["@/components/page/WorkBrowse.vue"], resolve),
          meta: { title: "作业试题浏览", roles: ["teacher"] },
        },
        {
          name: "workDetail",
          path: "detail/:qid",
          component: (resolve) =>
            require(["@/components/page/WorkDetail.vue"], resolve),
          meta: { title: "作业选题", roles: ["teacher"] },
        },
        {
          name: "workSmartKnowledge",
          path: "smart/knowledge",
          component: (resolve) =>
            require(["@/components/page/WorkSmartKnowledge.vue"], resolve),
          meta: { title: "智能选题", roles: ["teacher"] },
        },
        {
          name: "workChapter",
          path: "chapter",
          component: (resolve) =>
            require(["@/components/page/WorkChapter.vue"], resolve),
          meta: { title: "章节选题", roles: ["teacher"] },
        },
      ],
    },
    {
      name: "login",
      path: "/login",
      meta: {
        title: "登录",
      },
      component: () => import("@/components/page/Login.vue"),
    },
    {
      name: "authorizerResult",
      path: "/authorizerResult",
      component: (resolve) => require(["@/components/page/AuthorizerResult.vue"], resolve),
      meta: {
        title: "扫码授权回调",
      },
    },
    {
      name: "404",
      path: "/404",
      component: () => import("@/components/page/404.vue"),
      meta: {
        title: "页面不存在",
      },
    },
  ],
});
